import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { updateUserStep } from "../../actions/index";
import PickServiceTime from "./PickServiceTime";
import PickServicePackage from "./PickServicePackage";
import PickServiceDeatails from "./PickServiceDeatails";
import PickServiceSuccess from "./PickServiceSuccess";
import TypeOfService from "./TypeOfService";
import Address from "./Address";
import { ProgressBar } from "react-bootstrap";



class BookSession extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      times: [],
      paymentDetail: null
    };
  }
  nextStep = (paymentDetail) => {
    const { step } = this.state;
    this.setState({
      step: step + 1,
      paymentDetail: paymentDetail || null
    });
  };
  // Go back to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1
    });
  };

  callParentTomo = data1 => {
    this.setState({
      times: data1
    });
    console.log(this.state.times);
  };

  callParent = data => {
    this.setState({
      times: data
    });
  };
  componentDidMount() {
    const user = localStorage.getItem('token');

    if (!user) {
      this.props.history.replace("/login");
    }
    if (this.props.service) {
      this.setState({
        step: 1
      });
    }
  }

  render() {
    const { step } = this.state;
    console.log("BookSession props", this.props);

    // Add back/close icon to top right of booking session
    return (
      <div className="gym-background background-watermark">
        {this.props.userRenderPage === "BookSession" ? null : ''}
        <div className="book_index">
          <div className="container MQ_Tab_allign book_mq">
            <div className="row MQ_allign book_mq">
              <div className="col book_how_it_works">
                <div className="enroll-now-container bookhowcontainer">
                  <ul>
                    <strong>How it works</strong>
                    <li>1. Choose the service</li>
                    <li>2. Book Trial Session at 99/-(Refundable*)</li>
                    <li>3. Make payment and sit back.</li>
                    <li>4. We will send our best professional. If you like the session go ahead with our suitable package. </li>
                  </ul>
                </div>
              </div>

              <div className="trainer_container box-image booksession_container col-sm-7 col-md-7 col-xl-7 col-lg-7">
                {/* Back/Close Icon */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 8, zIndex: 1000 }}>
                  <button
                    aria-label="Close"
                    style={{ background: '#fff', border: '2px solid #ccc', borderRadius: '50%', width: 36, height: 36, fontSize: 22, fontWeight: 'bold', color: '#333', cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
                    onClick={() => {
                      if (this.props.history && this.props.history.push) {
                        this.props.history.push('/');
                      } 
                    }}
                    title="Close booking session"
                  >
                    &#10005;
                  </button>
                </div>
                <div className="trainer_header_container">
                  {(this.props.service === 'FITNESS') ? (
                    <h5>Personal Trainer at Home</h5>
                  ) : (
                    <h5>Yoga Trainer at Home</h5>
                  )}
                </div>{" "}
                <ProgressBar
                  now={(this.state.step * 100) / 9}
                  className="progressStyle"
                />
                <br />
                {(() => {
                  switch (step) {
                    case 0:
                      return <TypeOfService nextStep={this.nextStep} />;
                    case 1:
                      return <PickServiceTime nextStep={this.nextStep} />;
                    case 2:
                      return (
                        <PickServicePackage
                          nextStep={this.nextStep}
                          prevStep={this.prevStep}
                        />
                      );
                    case 3:
                      return (
                        <Address
                          nextStep={this.nextStep}
                          prevStep={this.prevStep}
                        />
                      );
                    case 4:
                      return (
                        <PickServiceDeatails
                          nextStep={this.nextStep}
                          prevStep={this.prevStep}
                        />
                      );
                    case 5:
                      return (
                        <PickServiceSuccess
                          nextStep={this.nextStep}
                          prevStep={this.prevStep}
                          paymentDetail={this.state.paymentDetail}
                        />
                      );
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = State => {
  return {
    userRenderPage: State.userDetail.userpage,
    service: State.serviceState.services
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateStep: step => {
      dispatch(updateUserStep(step));
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BookSession));
